import util from '../util'

let controller = 'CedentesCarteiras'

export default Object.assign({}, util.GetCrud(controller, ['get', 'post', 'put', 'persist']), {
  Combo: function (id) {
    return util.Axios.Get(controller + '/Combo', id)
  },
  GetAll: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  }
})
